import { ORDER_METHODS, RoomServiceLocationType } from '../../../../../services/exports/Constants';

export default {
  order_methods: {
    [ORDER_METHODS.ROOM_SERVICE]: {
      [RoomServiceLocationType.RoomService]: 'Na miejscu',
      [RoomServiceLocationType.TableService]: 'Na miejscu',
      both: 'Na miejscu',
    },
    [ORDER_METHODS.PICKUP]: 'Odbiór',
    [ORDER_METHODS.DELIVERY]: 'Dostawa',
  },
};
